<template>
  <div class="cont_body">
    <div class="list_cont">
      <div class="list_img" >
        <img :src="getImg(optionsData.thumbnail)" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{optionsData.title}} </h4>
        <div class="list_cont_mid" style="padding-right:2%">
          <p style="width:100%">简介：{{optionsData.contentAbstract}}</p>
        </div>
      </div>
    </div>
    <div class="list_bottom">
      <h4>知识产权内容</h4>
      <p v-html="optionsData.content">
        
      </p>
    </div>
  </div>
</template>
<script>
import {basicsEssayInfoweb} from "@/api/finance";
import {file_service} from "@/api/adminService";
export default {
  name: 'investor',
  components: {  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      optionsData:null,
    }
  },
  computed: {
  },
  created(){
    if(this.$route.query.queryData){
      this.getAction({
          url: basicsEssayInfoweb.getDetail,
          params: {
            id:this.$route.query.queryData
          }
      }).then(res => {
        this.optionsData = res
      })
     
      
    }
  },
	methods: {
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url) {
			this.$router.push(url)
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.cont_body{
	width:1200px;
	margin:0 auto 20px;
  display: block;
}
:deep(.ant-tag){
  background: #e4e6fc;
  border-radius: 2px;
  border:none;
  padding:2px 10px;
}
.list_cont{
  width: 100%;
  padding:20px 0;
  margin-bottom: 16px;
  &:hover{
    cursor: auto!important;
    box-shadow: none!important;
  }
  .list_img{
    width: 200px;
    height: 200px;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 10px 20px 25px;
    img{
      width:100%;
      height: 200px;
      object-fit:cover;
    }
  }
  .list_cont_body{
    flex: 6;
    h4{
      line-height: 50px;
    }
    .list_cont_mid{
      overflow: auto;
      padding-right:30%;
      color:#9c9c9c;
      p{
        display: block;
        float: left;
        width: 50%;
      }
    }
    .list_cont_end{
      margin-top: 20px;
      clear: both;
    }
  }
  .list_botton{
    flex: 1;
    :deep(.ant-btn){
      background: #1890ff;
      color:#fff
    }
  }
}
.list_bottom{
  h4{
    color:#1890ff;
    font-weight: 600;
    font-size: 22px;
    margin-bottom: 10px;
  }
  p{
    line-height: 25px;
  }
}
</style>